<app-modal-component [open]="openModal" labelledBy="utu-title" (dismiss)="onClose.emit()">
  <div class="set-modal">
    <form [formGroup]="testContactForm" (ngSubmit)="handleSubmit()" novalidate>
      <header class="set-modal__head">
        <div class="set-modal__intro">
          <h2 class="set-modal__title" id="utu-title">Edit test number</h2>
          <p class="set-modal__sub">Test messages go to the phone number below.</p>
        </div>
        <button type="button" class="bk-icon-btn" aria-label="Close" (click)="onClose.emit()">
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      </header>

      <div class="set-modal__body">
        @if (showFeedback && feedbackType !== 'success') {
          <p class="set-alert" role="alert">
            <span class="bk-sym" aria-hidden="true">error</span>
            <span>{{ feedbackMessage }}</span>
          </p>
        }

        <div class="set-grid">
          <input-field
            label="First name"
            [errorMessage]="submitted && testContactForm.controls.firstName.invalid ? 'Enter a first name.' : ''"
          >
            <input class="input-style" autocomplete="off" placeholder="First name" formControlName="firstName" />
          </input-field>

          <input-field
            label="Last name"
            [errorMessage]="submitted && testContactForm.controls.lastName.invalid ? 'Enter a last name.' : ''"
          >
            <input class="input-style" autocomplete="off" placeholder="Last name" formControlName="lastName" />
          </input-field>

          <input-field
            class="is-wide"
            label="Phone number"
            [errorMessage]="
              submitted && testContactForm.controls.primaryContactNumber.invalid
                ? 'Enter a valid phone number, including the country.'
                : ''
            "
          >
            <ngx-mat-input-tel
              formControlName="primaryContactNumber"
              [enablePlaceholder]="true"
              [preferredCountries]="['bw', 'za']"
              [enableSearch]="true"
              (countryChanged)="countryChanged($event)"
            />
          </input-field>

          <input-field
            class="is-wide"
            label="Email address (optional)"
            [errorMessage]="submitted ? emailErrorMsg : ''"
          >
            <input
              class="input-style"
              type="email"
              autocomplete="off"
              placeholder="name@company.com"
              formControlName="emailAddress"
            />
          </input-field>
        </div>
      </div>

      <footer class="set-modal__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="onClose.emit()">Cancel</button>
        <customizable-button title="Save changes" className="w-full" type="submit" [loading]="isCreating" [disabled]="isCreating" />
      </footer>
    </form>
  </div>
</app-modal-component>
